export * from './uni-language.model';
